<template>
  <div class="auditors-container">
    <span>{{ $t('stats.auditedBy') }}</span>
    <div class="grid">
      <div class="grid-item">
        <img src="@/assets/auditors/otter-sec.svg" alt="otter-sec" />
        <a
          href="https://docs.liquidswap.com/#ottersec"
          target="_blank"
          rel="noreferrer noopenner"
        >
          {{ $t('stats.viewReport') }}
        </a>
      </div>
      <div class="grid-item">
        <div class="img">
          <img src="@/assets/auditors/halborn.svg" alt="halborn" />
        </div>
        <a
          href="https://docs.liquidswap.com/#halborn"
          target="_blank"
          rel="noreferrer noopenner"
        >
          {{ $t('stats.viewReport') }}
        </a>
      </div>
      <div class="grid-item">
        <img src="@/assets/auditors/zellic.svg" alt="zellic" />
        <a
          href="https://docs.liquidswap.com/#zellic"
          target="_blank"
          rel="noreferrer noopenner"
        >
          {{ $t('stats.viewReport') }}
        </a>
      </div>
      <div class="grid-item">
        <img src="@/assets/auditors/movebit.svg" alt="movebit" />
        <a
          href="https://docs.liquidswap.com/#movebit"
          target="_blank"
          rel="noreferrer noopenner"
        >
          {{ $t('stats.viewReport') }}
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style scoped lang="scss">
.auditors-container {
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: inherit;
  padding: 32px 0rem;
  row-gap: 1rem;

  span {
    font-size: 11px;
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 2.4px;
  }
  img {
    object-fit: contain;
    @media screen and (max-width: 1024px) {
      width: 120px;
    }
  }
  a {
    font-size: 11px;
    font-weight: 400;
    color: #e5e4fa;
    opacity: 0.5;
    text-align: center;
    transition: 0.25s;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .grid {
    display: grid;
    justify-content: center;
    grid-template-columns: auto auto auto auto;
    column-gap: 1rem;
    margin: 0;

    @media screen and (max-width: 1024px) {
      row-gap: 0.5rem;
      grid-template-columns: auto;
      grid-row: auto auto auto auto;
    }
    .grid-item {
      padding: 0.5rem;
      display: inherit;
      row-gap: 1rem;
      align-items: end;
      align-content: end;
      justify-content: center;
      @media screen and (max-width: 1024px) {
        padding: 0.2rem;
      }

      &:last-child {
        @media screen and (max-width: 1024px) {
          margin-top: 0;
          grid-row: 3 / 4;
          grid-column: 1 / 2;
        }
      }
    }
  }
}
</style>
